export enum ROUTES {
  LOGIN = "/login",
  REGISTER = "REGISTER",
  DASHBOARD = "DASHBOARD",
  // more routes will be added here
}
